module.exports = __webpack_public_path__ + "static/media/laney.74c0abed.jpg";